<template>
<div >
     <Navigation></Navigation>
     <div id="breadcrumb">
        <div class="container">
            <ul>
                <li><router-link tag="a" to="/">Inicio</router-link></li>
                <li>Sitemap</li>
            </ul>
        </div>
    </div>

      <div class="container add_top_30 add_bottom_30 bg-white" v-if="!loading">
        <div class="row">
			
            <div class="col col-12 card p-4 text-center">
                 
                <h5>Especialidades</h5>
                <dl class="row" v-for="especiality in especialities.data" :key="especiality.id">
                   <dt class="col-sm-6 text-right">
                       <router-link tag="a" :to="`/doctors/${especiality.slug}`" >{{especiality.name}}</router-link>
                    </dt> 
                    <dd class="col-sm-6 text-left">
                        <ul>
                            <li v-for="medicEspeciality in especiality.medicEspecialities" :key="medicEspeciality.id">
                                <router-link tag="a" :to="`/doctor/${medicEspeciality.medic.id}-${medicEspeciality.medic.slug}`" class="" >{{medicEspeciality.medic.fullname}}</router-link>                                
                            </li>
                        </ul>
                    </dd>
                </dl>

            </div>
        </div>
    </div>

    <Footer></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

export default {
    name: "Sitemap",
    components: {
        Navigation,
        Footer,
    },
    data() {
        return {
            loading: true,
            sitemap:{},
        }
    },
    metaInfo() {
        return { 
            meta: [
                {name: 'robots', content: 'noindex,follow'} 
            ]
        }
    },
	apollo: {
        especialities: {
            query: gql`query{
                especialities(count:1000){
                    data {
                        id
                        name
                        slug
                        medicEspecialities{
                            id
                            medic{
                                id
                                fullname
                                slug
                            }
                            
                        }
                    }
                }
            }`,
            fetchPolicy: 'no-cache',
            result () {
                this.loading=false;
            },
        }
    },
};
</script>

<style scoped>


</style>
